import React, { useEffect, useState } from 'react';
import { Button, Divider, Spin, Row, Col, notification } from 'antd';
import { useDispatch } from 'react-redux';
import get from 'lodash/get';
import map from 'lodash/map';
import groupBy from 'lodash/groupBy';
import { salesChannelManagement } from '../../../redux/actions/marketPlaceAction';

const getChannelHeading = (channel) => {
  switch (channel) {
    case 'ONLINE':
      return 'Online Channels';
    case 'SAAS':
      return 'Saas Channels';
    default:
      return '--';
  }
};

const SelectSalesChannel = (props) => {
  const { onSubmitPayload, initialValues } = props;
  const [loading, setLoading] = useState(false);
  const [selectedChannel, setSelectedChannel] = useState(initialValues || null);
  const [onlineChannels, setOnlineChannels] = useState([]);
  const dispatch = useDispatch();

  const fetchOnlineChannels = () => {
    setLoading(true);
    dispatch(salesChannelManagement('list.sales_channels'))
      .then((result) => {
        setLoading(false);
        setOnlineChannels(groupBy(get(result, 'data'), 'type'));
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onSubmit = () => {
    if (!selectedChannel) {
      notification.error({
        message: 'Channel is required!',
        description: 'Please select a channel',
      });
      return;
    }
    onSubmitPayload(0, selectedChannel);
  };

  useEffect(() => {
    fetchOnlineChannels();
  }, []);

  return (
    <Spin spinning={loading}>
      {map(onlineChannels, (channels, channelType) => {
        return (
          <Row key={channelType}>
            <Divider
              orientation="left"
              dashed
              className="offering-channel-divider"
              plain={false}
            >
              {getChannelHeading(channelType)}
            </Divider>

            <div className="channels mt-30">
              {map(channels, (channel, i) => (
                <Button
                  key={i}
                  type={
                    get(selectedChannel, 'id') === get(channel, 'id')
                      ? 'primary'
                      : 'dashed'
                  }
                  className="offering-channel-btn"
                  onClick={() => {
                    setSelectedChannel(channel);
                  }}
                >
                  <img
                    src={get(channel, 'image')}
                    width={50}
                    height={50}
                    alt=""
                  />
                </Button>
              ))}
            </div>
          </Row>
        );
      })}
      <Row justify="center" className="mt-60">
        <Col xl={8}>
          <Button
            onClick={onSubmit}
            className="default-primary-btn"
            type="primary"
            block
          >
            Save & Proceed
          </Button>
        </Col>
      </Row>
    </Spin>
  );
};

export default SelectSalesChannel;
